import Close from '@mui/icons-material/Close'
import { DialogContent, DialogTitle, Grid, IconButton } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { CustomTextArea } from 'src/consumer/components/helperComponents'
import { DURATION_OPTIONS_PRESCRIPTION } from 'src/consumer/constants'
import { genericHandleChange } from 'src/consumer/helpers/utilFunctions'
import PillInputComponent from '../common/PillInputComponent'

export default function ObservationsContextForm({
  item: observation,
  setItem: setObservation,
  saveItem,
  closeMenu,
}) {
  // Local state for text inputs to give immediate visual feedback while debouncing parent context updates
  const [noteLocal, setNoteLocal] = useState(observation?.note || '')
  const _noteTimerRef = useRef(null)
  const _setObservationRef = useRef(setObservation)
  _setObservationRef.current = setObservation

  // Sync local state when observation.note changes from outside (e.g., initial load)
  useEffect(() => {
    setNoteLocal(observation?.note || '')
  }, [observation?.note])

  // Flush any pending debounced update on unmount (e.g., when context panel closes)
  useEffect(() => {
    return () => {
      clearTimeout(_noteTimerRef.current)
    }
  }, [])

  function handleObservationChange(e) {
    genericHandleChange(e, setObservation)
  }

  return (
    <>
      <DialogTitle
        sx={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'center' }}
      >
        {/* <Button
          color="success"
          variant="contained"
          endIcon={<Save />}
          onClick={() => saveItem(observation)}
          sx={{ flexShrink: 0 }}
        >
          Save
        </Button> */}
        <div>
          <span>{observation?.label}</span>
        </div>
        <IconButton sx={{ flexShrink: 0 }} onClick={closeMenu}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item md={12}>
            <h5>Note</h5>
          </Grid>
          <Grid item md={12}>
            <CustomTextArea
              id="note"
              onChange={(e) => {
                const val = e.target.value
                setNoteLocal(val)
                clearTimeout(_noteTimerRef.current)
                _noteTimerRef.current = setTimeout(() => {
                  _setObservationRef.current((prev) => ({ ...prev, note: val }))
                }, 300)
              }}
              value={noteLocal}
            />
          </Grid>
          <Grid item md={12}>
            <h5>Duration</h5>
          </Grid>
          <Grid item md={12}>
            <PillInputComponent
              value={observation?.duration}
              handleChange={handleObservationChange}
              valueKey="duration"
              options={DURATION_OPTIONS_PRESCRIPTION}
              getOptionValue={(option) => option?.value}
              getOptionLabel={(option) => option?.label}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </>
  )
}
